import gql from 'graphql-tag';

export const FETCH_TIME_SLOTS = gql`
  query(
    $contractId: Int!
    $timeRange: TimeRangeInput!
    $providerId: String
    $appointmentId: String
    $mode: TimeSlotOutputMode
  ) {
    getTimeSlots(
      contractId: $contractId
      timeRange: $timeRange
      providerId: $providerId
      appointmentId: $appointmentId
      mode: $mode
    ) {
      timeSlots {
        from
        to
      }
    }
  }
`;
